import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Transition as _Transition, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "layout-system"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_Transition, _normalizeProps(_guardReactiveProps(_ctx.layoutTransition)), {
              default: _withCtx(() => [
                (_ctx.layout.component)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: _ctx.layoutKey,
                      class: "layout-system__layout"
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.layout.component), _normalizeProps(_guardReactiveProps({ ..._ctx.layout.props })), {
                        default: _withCtx(() => [
                          _createVNode(_Transition, _normalizeProps(_guardReactiveProps(_ctx.viewTransition)), {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock("div", {
                                key: _ctx.viewKey,
                                class: "layout-system__view"
                              }, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                              ]))
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        _: 2
                      }, 1040))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}